import { Container, Stack } from 'react-bootstrap';
import {
    ICaseResolutionModel,
    ICaseResolutionPlanStepModel,
} from '../../../../interfaces/ICaseResolutionModel';

import CheckmateApiClient from '../../../../services/apiClient';
import { IDocumentModel } from '../../../../interfaces/ICase';

const _apiClient = new CheckmateApiClient();

export interface PDReviewProps {
    caseResolutionCase: ICaseResolutionModel;
}

export function PDReview({ caseResolutionCase }: PDReviewProps) {
    const currentCase: any = caseResolutionCase;
    const adminTrafficLight = currentCase.steps[3].stepData.ratings[0].value;
    const legalTrafficLight = currentCase.steps[4].stepData.ratings[0].value;

    const getAdminColor = (star: number) => {
        if (star > adminTrafficLight) {
            return '#e4e5e9';
        }
        if (adminTrafficLight === 1) {
            return '#ff0000';
        }
        if (adminTrafficLight === 2) {
            return '#f7b730';
        }
        return '#4abdac';
    };

    const getLegalColor = (star: number) => {
        if (star > legalTrafficLight) {
            return '#e4e5e9';
        }
        if (legalTrafficLight === 1) {
            return '#ff0000';
        }
        if (legalTrafficLight === 2) {
            return '#f7b730';
        }
        return '#4abdac';
    };

    return (
        <Stack direction="horizontal" gap={5}>
            <div style={{ height: '75px' }}>
                <div className="bold">Admin QC Rating</div>
                <Stack direction='horizontal' gap={2}>
                    {[1, 2, 3].map((star) => (
                        <button
                            className="btn"
                            style={{
                                border: 'none',
                                padding: 0,
                                fontSize: '2rem',
                                cursor: 'default',
                            }}
                            key={star}
                        >
                            <i
                                className={'fa-solid fa-circle'}
                                style={{ color: getAdminColor(star) }}
                            ></i>
                        </button>
                    ))}
                </Stack>
            </div>
            <div style={{ height: '75px' }}>
                <div className="bold">Legal QC Rating</div>
                <Stack direction='horizontal' gap={2}>
                    {[1, 2, 3].map((star) => (
                        <button
                            className="btn"
                            style={{
                                border: 'none',
                                padding: 0,
                                fontSize: '2rem',
                                cursor: 'default',
                            }}
                            key={star}
                        >
                            <i
                                className={'fa-solid fa-circle'}
                                style={{ color: getLegalColor(star) }}
                            ></i>
                        </button>
                    ))}
                </Stack>
            </div>
        </Stack>
    );
}
